'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (key) {
  return key.replace(/\.[0-9]+\./g, '.$.');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/node_modules/simple-react-form/lib/utility/replace-index-keys.js
// module id = 2691
// module chunks = 0